'use client';
import TemplateLayout from '@/layout/TemplateLayout';

export default function Layout({ children }) {
  return <TemplateLayout>{children}</TemplateLayout>;
}
